/**
 * A busca "como se digita" das listas: sem caixa, sem acento, por palavra.
 *
 * É a mesma regra dos filtros de texto da API (`BuscaDeTexto`): cada palavra
 * do termo precisa aparecer em algum dos textos, em qualquer posição — "rele
 * bomba" acha "Relé da bomba". Igualdade exata deixava de fora o que a pessoa
 * procurava por um acento ou pela ordem das palavras.
 */

export function normalizarBusca(texto: string): string {
  return texto.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim()
}

/** `true` quando todas as palavras de `termo` aparecem em algum dos `textos`. */
export function casaBusca(termo: string, ...textos: (string | null | undefined)[]): boolean {
  const palavras = normalizarBusca(termo).split(/\s+/).filter(Boolean)
  if (palavras.length === 0) return true
  const alvo = textos.map((t) => normalizarBusca(t ?? "")).join(" ")
  return palavras.every((p) => alvo.includes(p))
}
